export const COL_SIZES = {
    SMALL: 160,
    MEDIUM: 225,
    LARGE: 330,
};

export const chooseColumnWidthByTitle = (title: string): number => {
    return title.length >= 60 ? COL_SIZES.LARGE : title.length >= 30 ? COL_SIZES.MEDIUM : COL_SIZES.SMALL;
};
